import debounce from 'lodash/debounce';

document.addEventListener('DOMContentLoaded', () => {
  const formDiv = document.getElementById('store_products_form');
  if (formDiv == null) {
    return;
  }

  const anyOneChoiceBlock = document.querySelector('.any-one-choice');
  const inputsOfAnyOneChoice = (anyOneChoiceBlock as HTMLElement).querySelectorAll("input[type='number']");
  const storeProductLabelSelect = document.getElementById('chirashiru_store_product_chirashiru_store_product_label_id') as HTMLSelectElement;
  const storeProductPriceInput = document.getElementById('chirashiru_store_product_price');
  const storeProductPoint = document.getElementById('chirashiru_store_product_number_for_point') as HTMLInputElement;
  const pointFormatLabel = document.getElementById('point_format_label') as HTMLElement;
  const pointFormatSelect = document.getElementById('chirashiru_store_product_point_format') as HTMLSelectElement;
  const includedTaxRadioButtonTrue = document.getElementById(
    'chirashiru_store_product_included_tax_true',
  ) as HTMLInputElement;
  const includedTaxRadioButtonFalse = document.getElementById(
    'chirashiru_store_product_included_tax_false',
  ) as HTMLInputElement;
  const taxRateRadioButton008 = document.getElementById(
    'chirashiru_store_product_tax_rate_0_08',
  ) as HTMLInputElement;
  const taxRateRadioButton010 = document.getElementById(
    'chirashiru_store_product_tax_rate_0_1',
  ) as HTMLInputElement;
  const roundTypeRadioButtonDefalut = document.getElementById(
    'chirashiru_store_product_round_type_'
  ) as HTMLInputElement;
  const roundTypeRadioButtonRoundUp = document.getElementById(
    'chirashiru_store_product_round_type_round_up'
  ) as HTMLInputElement;
  const roundTypeRadioButtonRoundDown = document.getElementById(
    'chirashiru_store_product_round_type_round_down'
  ) as HTMLInputElement;
  const roundTypeRadioButtonRound = document.getElementById(
    'chirashiru_store_product_round_type_round'
  ) as HTMLInputElement;

  storeProductPoint.value ? pointFormatSelect.disabled = false : pointFormatSelect.disabled = true;

  inputsOfAnyOneChoice.forEach(input => {
    input.addEventListener(
      'keyup',
      debounce(() => {
        exclusivelyDisableInputs(input as HTMLInputElement, inputsOfAnyOneChoice);
      }, 300),
    );
    input.addEventListener('change', () => {
      exclusivelyDisableInputs(input as HTMLInputElement, inputsOfAnyOneChoice);
    });
    (input.parentElement as HTMLElement).addEventListener('click', () => {
      if ((input as HTMLInputElement).readOnly) {
        alert('入力されている価格・割引・ポイントの項目を空にしてください');
      }
    });
  });

  const exclusivelyDisableInputs = (input: HTMLInputElement, inputs: NodeList) => {
    const id = input.id;
    const value = input.value;
    inputs.forEach(el => {
      (el as HTMLInputElement).readOnly = false;
    });
    if (id === 'chirashiru_store_product_number_for_point' && value) {
      pointFormatSelect.disabled = false;
      toggleRequiredClassToPointLabel();
    } else {
      pointFormatSelect.value = '';
      pointFormatSelect.disabled = true;
      toggleRequiredClassToPointLabel();
    }

    if (!value || value == '') {
      return;
    }
    const inputArray = [].map.call(inputs, el => {
      return el;
    });
    const exclusiveInputArray = inputArray.filter(el => {
      return (el as HTMLElement).id != id;
    });
    [].forEach.call(exclusiveInputArray, el => {
      (el as HTMLInputElement).value = '';
      (el as HTMLInputElement).readOnly = true;
    });
  };

  const toggleLabelSupplementInput = () => {
    const labelSupplementInput = document.getElementById(
      'chirashiru_store_product_label_supplement',
    );
    const selectedOptionLabel = getSelectOptionLabel(storeProductLabelSelect);
    const parentDiv = (labelSupplementInput as HTMLElement).parentElement;
    const formGroup = (parentDiv as HTMLElement).parentElement;
    if (selectedOptionLabel.match(/◯/)) {
      (formGroup as HTMLElement).style.display = 'block';
      (labelSupplementInput as HTMLInputElement).disabled = false;
    } else {
      (formGroup as HTMLElement).style.display = 'none';
      (labelSupplementInput as HTMLInputElement).disabled = true;
    }
  };

  const toggleStartEndTimeLabels = () => {
    const startTimeLabelSelect = document.getElementById(
      'chirashiru_store_product_start_time_label',
    );
    const endTimeLabelSelect = document.getElementById('chirashiru_store_product_end_time_label');
    const selectedOptionLabel = getSelectOptionLabel(storeProductLabelSelect);
    const parentDivOfStartTimeLabel = (startTimeLabelSelect as HTMLElement).parentElement;
    const formGroupOfStartTimeLabel = (parentDivOfStartTimeLabel as HTMLElement).parentElement;
    const parentDivOfEndTimeLabel = (endTimeLabelSelect as HTMLElement).parentElement;
    const formGroupOfEndTimeLabel = (parentDivOfEndTimeLabel as HTMLElement).parentElement;
    if (selectedOptionLabel.match(/タイムセール/)) {
      (formGroupOfStartTimeLabel as HTMLElement).style.display = 'block';
      (formGroupOfEndTimeLabel as HTMLElement).style.display = 'block';
      (startTimeLabelSelect as HTMLSelectElement).disabled = false;
      (endTimeLabelSelect as HTMLSelectElement).disabled = false;
    } else {
      (formGroupOfStartTimeLabel as HTMLElement).style.display = 'none';
      (formGroupOfEndTimeLabel as HTMLElement).style.display = 'none';
      (startTimeLabelSelect as HTMLSelectElement).disabled = true;
      (endTimeLabelSelect as HTMLSelectElement).disabled = true;
    }
  };

  const getSelectOptionLabel = (select: HTMLSelectElement): string => {
    const selectedIndex = select.selectedIndex;
    const selectedOption = select.options[selectedIndex];
    const selectedOptionLabel = selectedOption.innerText;
    return selectedOptionLabel;
  };

  const toggleIncludedTaxRadioButtons = () => {
    const value = (storeProductPriceInput as HTMLInputElement).value;
    const label = (includedTaxRadioButtonTrue as HTMLElement).parentElement;
    const parentDiv = (label as HTMLElement).parentElement;
    const formGroup = (parentDiv as HTMLElement).parentElement;
    if (value.length) {
      (formGroup as HTMLElement).style.display = 'block';
      includedTaxRadioButtonTrue.disabled = false;
      includedTaxRadioButtonFalse.disabled = false;
    } else {
      (formGroup as HTMLElement).style.display = 'none';
      includedTaxRadioButtonTrue.disabled = true;
      includedTaxRadioButtonFalse.disabled = true;
    }
    toggleTaxRateRadioButtons();
    toggleRoundTypeRadioButtons();
  };

  const toggleTaxRateRadioButtons = () => {
    const label = (taxRateRadioButton008 as HTMLElement).parentElement;
    const parentDiv = (label as HTMLElement).parentElement;
    const formGroup = (parentDiv as HTMLElement).parentElement;
    if (includedTaxRadioButtonFalse.checked && !includedTaxRadioButtonFalse.disabled) {
      (formGroup as HTMLElement).style.display = 'block';
      taxRateRadioButton008.disabled = false;
      taxRateRadioButton010.disabled = false;
    } else {
      (formGroup as HTMLElement).style.display = 'none';
      taxRateRadioButton008.disabled = true;
      taxRateRadioButton010.disabled = true;
    }
  }

  const toggleRoundTypeRadioButtons = () => {
    const label = (roundTypeRadioButtonDefalut as HTMLElement).parentElement;
    const parentDiv = (label as HTMLElement).parentElement;
    const formGroup = (parentDiv as HTMLElement).parentElement;
    if (includedTaxRadioButtonFalse.checked && !includedTaxRadioButtonFalse.disabled) {
      (formGroup as HTMLElement).style.display = 'block';
      roundTypeRadioButtonDefalut.disabled = false;
      roundTypeRadioButtonRoundUp.disabled = false;
      roundTypeRadioButtonRoundDown.disabled = false;
      roundTypeRadioButtonRound.disabled = false;
    } else {
      (formGroup as HTMLElement).style.display = 'none';
      roundTypeRadioButtonDefalut.disabled = true;
      roundTypeRadioButtonRoundUp.disabled = true;
      roundTypeRadioButtonRoundDown.disabled = true;
      roundTypeRadioButtonRound.disabled = true;
    }
  }

  const toggleRequiredClassToPointLabel = () => {
    if (storeProductPoint.value) {
      pointFormatLabel.classList.add('required');
    } else {
      pointFormatLabel.classList.remove('required');
    }
  }

  toggleRequiredClassToPointLabel();

  storeProductLabelSelect.addEventListener('change', () => {
    toggleLabelSupplementInput();
    toggleStartEndTimeLabels();
  });

  (storeProductPriceInput as HTMLInputElement).addEventListener(
    'keyup',
    debounce(() => {
      toggleIncludedTaxRadioButtons();
    }, 500)
  );

  includedTaxRadioButtonTrue.addEventListener('change', () => {
    toggleTaxRateRadioButtons();
    toggleRoundTypeRadioButtons();
  });
  includedTaxRadioButtonFalse.addEventListener('change', () => {
    toggleTaxRateRadioButtons();
    toggleRoundTypeRadioButtons();
  });

  const initialize = () => {
    toggleLabelSupplementInput();
    toggleStartEndTimeLabels();
    toggleIncludedTaxRadioButtons();
  }

  initialize();
});
